import Terms from "./Terms";

export default [
    {
        path: "/terms-and-conditions",
        name: "terms-and-conditions",
        meta: {
            auth: undefined,
            basePath: false,
        },
        component: Terms,
        meta: {
            auth: undefined,
        },
    },
];
